export enum DiagramTab {
	Dependencies = 'Dependencies',
	Diagram = 'Diagram',
	Overview = 'Overview',
	Validation = 'Validation',
}
